/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { STORAGE_KEY } from '~/constants';
import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* signIn({ payload }) {
  try {
    const response = yield call(() => axios.post(
      `${process.env.REACT_APP_DEV_MICRO_APP}/clients/web/login`,
      payload,
    ));
    const {
      token_type, access_token, refresh_token, expires_in,
    } = response.data;
    localStorage.setItem(
      STORAGE_KEY.ACCESS_TOKEN,
      `${token_type} ${access_token}`,
    );
    localStorage.setItem(STORAGE_KEY.REFRESH_TOKEN, refresh_token);
    localStorage.setItem(STORAGE_KEY.EXPIRES_IN, expires_in);
    yield put(Actions.signInSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.signInFailure(messages));
    }
  }
}

function* signOut() {
  try {
    yield call(() => axiosMicro.delete(
      `${process.env.REACT_APP_DEV_MICRO_APP}/logout`,
    ));
    localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEY.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEY.EXPIRES_IN);
    yield put(Actions.signOutSuccess());
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.signOutFailure(messages));
    }
  }
}

function* changePassword({ payload }) {
  try {
    const { id, currentPassword, newPassword } = payload;
    yield call(() => axiosMicro.patch(`/users/${id}/password`, {
      current_password: currentPassword,
      new_password: newPassword,
    }));
    yield put(Actions.changePasswordSuccess());
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.changePasswordFailure(messages));
    }
  }
}

function* requireChangePassword({ payload }) {
  try {
    const { id, currentPassword, newPassword } = payload;
    yield call(() => axiosMicro.patch(`/users/${id}/password`, {
      current_password: currentPassword,
      new_password: newPassword,
    }));
    yield put(Actions.requireChangePasswordSuccess());
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.requireChangePasswordFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.signInRequest, signIn);
  yield takeLatest(Actions.signOutRequest, signOut);
  yield takeLatest(Actions.changePasswordRequest, changePassword);
  yield takeLatest(Actions.requireChangePasswordRequest, requireChangePassword);
}
